import { all } from 'redux-saga/effects';
import adjustmentSaga from './adjustment';
import purchaseOrderSaga from './purchaseOrder';
import summarySaga from './summary';
import supplierSaga from './supplier';
import transferSaga from './transfer';
import ingredientSubscriptionSaga from './ingredientSubscription';

export default function* inventorySaga() {
  yield all([
    adjustmentSaga(),
    purchaseOrderSaga(),
    summarySaga(),
    supplierSaga(),
    transferSaga(),
    ingredientSubscriptionSaga(),
  ]);
}
